var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAsideMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 40169"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.9717 7.36921V18.777C20.9717 19.4746 20.5549 20.0998 19.9207 20.3717L15.8613 22.1114C15.2452 22.3741 14.5475 22.3923 13.9223 22.1567L8.87535 20.2629C8.28639 20.0455 7.634 20.0455 7.04504 20.2629L2.19743 22.0842C1.62659 22.2926 1.02856 21.8758 1.02856 21.2687V9.85191C1.02856 9.12703 1.47255 8.48371 2.15212 8.23L7.04504 6.39062",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.96924 8.65576V18.1879",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.9009 15.5874V20.7884",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.2124 7.59516C15.0881 7.59516 15.798 6.88524 15.798 6.0095C15.798 5.13376 15.0881 4.42383 14.2124 4.42383C13.3366 4.42383 12.6267 5.13376 12.6267 6.0095C12.6267 6.88524 13.3366 7.59516 14.2124 7.59516Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.5524 6.00985C18.5524 8.00326 15.662 11.3467 14.5294 12.724C14.2847 13.023 13.8045 13.023 13.5599 12.724C12.4272 11.3467 9.8811 8.01232 9.8811 6.00985C9.8811 3.4909 12.0648 1.67871 14.2122 1.67871C16.3597 1.67871 18.5434 3.4909 18.5434 6.00985H18.5524Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAsideMap);
export default __webpack_public_path__ + "static/media/ic_aside_map.ab7af7c820b14ec93ea5f00e04cb5983.svg";
export { ForwardRef as ReactComponent };